<template>
    <section class="content-wrapper">
        <pageLoader v-if="loadershow" :loadingText="'Traitement des données en cours'"/>
        <div class="row">
            <div class="col-md-6 offset-md-3">
                <div class="card">
                    <div class="card-body">
                        <div class="auth-form-light text-left p-5">
                            <div class="brand-logo text-center">
                            <img src="../assets/images/logo.png">
                            </div>
                            <h4 class="text-center mt-4">Un code a été envoyé à votre adresse mail</h4>
                            <h6 class="font-weight-light text-center">Veuillez entrer le code envoyé</h6>
                            <form class="pt-3" @submit.prevent="handleSubmit">
                                <!-- token -->
                            <b-form-group class="d-none" id="token" label="Code" label-for="example-input-1">
                                <b-form-input
                                  id="example-input-1"
                                  name="example-input-1"
                                  v-model.trim="token"
                                  disabled
                                  :state="$v.token.$dirty ? !$v.token.$error : null"
                                  aria-describedby="input-1-live-feedback"
                                ></b-form-input>
                                <b-form-invalid-feedback id="input-1-live-feedback">
                                  Veuillez entrer le bon code
                                </b-form-invalid-feedback>
                            </b-form-group>

                            <!-- nouveau mot de passe -->
                            <b-form-group id="password1" label="Nouveau mot de passe" label-for="example-input-1">
                                <b-form-input
                                    id="example-input-1"
                                    name="example-input-1"
                                    type="password"
                                    v-model="password1"
                                    :state="$v.password1.$dirty ? !$v.password1.$error : null"
                                    aria-describedby="input-1-live-feedback"
                                ></b-form-input>
                                <b-form-invalid-feedback id="input-1-live-feedback">
                                    Ce champ ne doit pas être vide
                                </b-form-invalid-feedback>
                            </b-form-group>

                              <!-- Confirmation du mot de passe -->
                            <b-form-group id="password-2" label="Confirmer le mot de passe" label-for="example-input-1">
                                <b-form-input
                                  id="example-input-1"
                                  name="example-input-1"
                                  type="password"
                                  v-model="password2"
                                  :state="$v.password2.$dirty ? !$v.password2.$error : null"
                                  aria-describedby="input-1-live-feedback"
                                ></b-form-input>
                                <b-form-invalid-feedback id="input-1-live-feedback">
                                  Les mots de passes ne sont pas les mêmes
                                </b-form-invalid-feedback>
                            </b-form-group>
                            <div class="mt-3">
                                <button class="btn btn-block btn-primary  btn-lg font-weight-medium auth-form-btn">Changer mon mot de passe</button>
                            </div>
                            <div class="my-2 d-flex justify-content-between align-items-center">
                            </div>

                            <div>
                                <p class="text-center">Vous n'avez pas reçu l'email? N'oubliez pas de regarder  dans vos spams.</p>
                            </div>
                            <!-- <div class="text-center mt-4 font-weight-light">
                                Vous n'avez pas reçu de code? <router-link to="/authentification" class="text-primary">Renvoyer</router-link>
                            </div> -->
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
const axios = require('axios').default
import { validationMixin } from 'vuelidate'
import { required, sameAs} from 'vuelidate/lib/validators'
import pageLoader from '../components/pageLoader.vue'
export default {
    name: 'new-password',
    mixins: [validationMixin],
    components:{
        pageLoader
    },
    data() {
        return {
            token: '',
            pwd: '',
            password1:'',
            password2:'',
            ulid:'',
            loadershow:false
        }
    },
    validations: {
        token: {
            required
        },
        password1: {
            required
        },
        password2: {
            required,
            sameAs:sameAs('password1')
        }
    },
    methods: {
        handleSubmit(){
            this.$v.$touch()
            if (this.$v.$anyError) {
                return
            }
            this.getMyInfos()
        },
        getMyInfos(){
        this.loadershow=true
        localStorage.setItem('token', this.token)
        // vérification token
        axios.get('myinfos', {
            headers: {
                'X-AUTH-TOKEN': this.token
            }
        })
        .then(async res=> {
            this.ulid= res.data.ulid
            await this.putPassword()
            console.log({res})
        })
        .catch(() => {
            alert('Le lien que vous avez ouvert est n\'est plus valide')
            this.loadershow=false
            })
        },
        putPassword(){
            axios.put(`myinfos/${this.ulid}`,{
                password: this.password2
            },{
                headers: {
                    'X-AUTH-TOKEN': localStorage.getItem('token')
                }
            })
            .then(res => {
                console.log(res)
                alert('Votre mot de passe a été modifié avec succès')
                this.$router.push({
                    name:"login"
                })
            })
            .catch(err => {
                console.log(err)
            })
        }
    },
    mounted() {
        this.ulid=this.$route.params.ulid
        this.token = this.$route.params.token
    }
}
</script>